import React, { useState, useRef, useCallback } from 'react'
import {
  VKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  VKIcon,
  TelegramIcon,
  WhatsappIcon
} from 'react-share'
import { PATHS } from '~shared/constants/paths'
import { useClickOutside } from '~shared/utils/useClickOutSide'
import { cn } from '~shared/utils/cn'
import { ArrowBackIcon } from '~shared/icons/arrow-back'
import { ShareIcon } from '~shared/icons/share-icon'
import { getJournalPath } from '~shared/utils/getJournalPath'

type TSocialProps = {
  isLeftSide?: boolean
  isBottom?: boolean
  journalSlug?: string | null
  tagSlug?: string | null
  className?: string
}

export const Social = ({
  isLeftSide,
  isBottom,
  journalSlug,
  tagSlug,
  className
}: TSocialProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const urlPage = `${PATHS.front.root.index}${getJournalPath(tagSlug, journalSlug)}`

  const handleClipboardLink = () => {
    navigator.clipboard.writeText(urlPage).then(
      () => alert('Ссылка скопирована в буфер обмена.'),
      () => alert('Произошла ошибка... Повторите еще раз.')
    )
  }

  const handleClose = useCallback(() => setIsVisible(false), [])
  const toggleVisibility = () => setIsVisible(prev => !prev)

  useClickOutside(dropdownRef, handleClose)

  return (
    <div
      className={cn(
        `relative flex items-center gap-[16px] ${isLeftSide ? '' : 'ml-auto'}`,
        className
      )}>
      <div
        onClick={toggleVisibility}
        className='flex items-center justify-center gap-[8px] cursor-pointer hover:text-accent duration-200'>
        <p className='text-[14px] underline underline-offset-4'>Поделиться</p>
        <ArrowBackIcon />
      </div>

      {isVisible && (
        <div
          ref={dropdownRef}
          className={`
            absolute z-[100] w-max h-auto p-[16px] rounded-[10px] bg-white
            flex flex-col gap-[16px] shadow-2xl
            [&_div]:flex [&_div]:flex-row [&_div]:gap-[8px]
            [&_div>*]:flex [&_div>*]:flex-row [&_div>*]:gap-[8px]
            ${isBottom ? 'top-[100%] left-0 mt-[8px]' : 'bottom-[100%] right-0 mb-[8px]'}
          `}>
          <div className='cursor-pointer'>
            <VKShareButton url={urlPage}  className='flex items-center'>
              <VKIcon className='w-[25px] h-[25px] rounded-[4px]'/>
              <p className='text-[13px]'>Vkontakte</p>
            </VKShareButton>
          </div>

          <div className='cursor-pointer'>
            <TelegramShareButton url={urlPage} className='flex items-center'>
              <TelegramIcon  className='w-[25px] h-[25px] rounded-[4px]'/>
              <p className='text-[13px]'>Telegram</p>
            </TelegramShareButton>
          </div>

          <div className='cursor-pointer'>
            <WhatsappShareButton url={urlPage}  className='flex items-center'>
              <WhatsappIcon  className='w-[25px] h-[25px] rounded-[4px]'/>
              <p className='text-[13px]'>{`What's App`}</p>
            </WhatsappShareButton>
          </div>

          <div onClick={handleClipboardLink} className='cursor-pointer'>
            <ShareIcon />
            <p className='text-[13px]'>Скопировать ссылку</p>
          </div>
        </div>
      )}
    </div>
  )
}
